import { render, staticRenderFns } from "./AboutInfo.vue?vue&type=template&id=aca286dc&scoped=true"
import script from "./AboutInfo.vue?vue&type=script&lang=js"
export * from "./AboutInfo.vue?vue&type=script&lang=js"
import style0 from "./AboutInfo.vue?vue&type=style&index=0&id=aca286dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca286dc",
  null
  
)

export default component.exports